import { useTranslation } from 'react-i18next';

import TitleQuotation from '../../components/title-quotation';

import Hr from '../../components/Style/hr';
import SystempayComponent from '../../components/Paiement/systempay';

export default function StepPayment({ formData, returnedData }) {
    const { t } = useTranslation();

    const handleReturnedData = (data) => {
        returnedData(data);
    };

    return (
        <>
            <TitleQuotation title={t('pageServices.step4.welcomeMessage')} description={t('pageServices.step4.description')} step="4" />
            <Hr />
            <SystempayComponent data={formData} returnedData={handleReturnedData} />
        </>
    );
}